class HeroSplitSlideshow extends HTMLElement {
  connectedCallback() {
    this.slideCount = parseInt(this.dataset.slideCount, 10) || 1;
    this.currentIndex = 0;
    this.intervalMs = (Number(this.dataset.interval) || 6) * 1000;
    this.timer = null;

    this.track = this.querySelector('.split-hero__track');
    this.texts = Array.from(this.querySelectorAll('.split-hero__text'));
    this.buttons = Array.from(this.querySelectorAll('.split-hero__button'));
    this.nextButton = this.querySelector('.split-hero__next');
    this.peek = this.querySelector('.split-hero__peek');
    this.peekImage = this.querySelector('.split-hero__peek-image');
    this.peekProgress = this.querySelector('.split-hero__peek-progress rect');

    // Each slide is 100% of the media column's own width, so the track can
    // slide between them with a plain percentage transform - no measuring
    // or resizing needed, unlike the old fixed peek-width layout this
    // replaced.
    this.slides = Array.from(this.querySelectorAll('.split-hero__slide'));

    if (this.slideCount <= 1) return;

    this.updatePeekImage();
    this.nextButton?.addEventListener('click', () => this.goToNext(true));
    this.peek?.addEventListener('click', () => this.goToNext(true));
    this.startAutoRotate();
  }

  disconnectedCallback() {
    this.stopAutoRotate();
  }

  goToNext(userInitiated) {
    this.currentIndex = (this.currentIndex + 1) % this.slideCount;
    this.applyTransform();
    this.updateActiveText();
    this.updatePeekImage();
    this.playProgress();
    if (userInitiated) this.startAutoRotate();
  }

  applyTransform() {
    if (!this.track) return;
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  updateActiveText() {
    this.texts.forEach((text, index) => {
      text.classList.toggle('is-active', index === this.currentIndex);
    });
    this.buttons.forEach((button, index) => {
      button.classList.toggle('is-active', index === this.currentIndex);
    });
  }

  // Mirrors the upcoming slide's own image into .split-hero__peek-image
  // (a fixed, center-cropped thumbnail) instead of showing whatever raw
  // edge pixels a plain crop of that slide would happen to expose.
  updatePeekImage() {
    if (!this.peekImage) return;
    const nextIndex = (this.currentIndex + 1) % this.slideCount;
    const nextImg = this.slides[nextIndex]?.querySelector('img');
    if (!nextImg) return;
    this.peekImage.src = nextImg.currentSrc || nextImg.src;
    this.peekImage.alt = nextImg.alt || '';
  }

  startAutoRotate() {
    this.stopAutoRotate();
    this.playProgress();
    this.timer = window.setInterval(() => this.goToNext(false), this.intervalMs);
  }

  stopAutoRotate() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  // Draws the countdown ring around the preview card by animating its
  // stroke-dashoffset from 100 to 0 over the autoplay interval. Restarted
  // (transition removed, dashoffset reset, transition restored) every time
  // the slide changes, whether from the timer or a manual click.
  playProgress() {
    if (!this.peek || !this.peekProgress) return;
    this.peek.classList.remove('is-animating');
    this.peekProgress.style.transitionDuration = '0s';
    this.peekProgress.style.strokeDashoffset = '100';
    void this.peekProgress.getBoundingClientRect();
    this.peek.classList.add('is-animating');
    this.peekProgress.style.transitionDuration = `${this.intervalMs}ms`;
    requestAnimationFrame(() => {
      this.peekProgress.style.strokeDashoffset = '0';
    });
  }
}

customElements.define('hero-split-slideshow', HeroSplitSlideshow);
